class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.summaryElement = this.mainDetailsToggle.querySelector('summary');
    this.content = this.summaryElement.nextElementSibling;

    this.isMegaMenu = this.mainDetailsToggle.classList.contains('header-mega_menu');

    if (this.isMegaMenu) {
      this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
      this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
      this.summaryElement.addEventListener('click', this.onMegaMenuClick.bind(this));
    }

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onMouseEnter() {
    if (this.content && this.content.children.length > 0) {
      this.open();
    }
  }

  onMouseLeave() {
    this.close();
  }

  onFocusOut() {
    if (!this.contains(document.activeElement)) {
      this.close();
    }
  }

  onToggle() {
    if (!this.isMegaMenu && this.content) {
      if (!this.animations) {
        this.animations = this.content.getAnimations();
      }

      if (this.mainDetailsToggle.hasAttribute('open')) {
        this.animations.forEach(animation => animation.play());
      } else {
        this.animations.forEach(animation => animation.cancel());
      }
    }
  }

  onMegaMenuClick(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.summaryElement.setAttribute('aria-expanded', true);
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.summaryElement.setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);
